<template>
  <v-content>
    <router-view/>

    <dashboard-core-footer v-model="value"/>
  </v-content>
</template>

<script>
import {eventBus} from "@/services/event-bus";

export default {
  name: 'DashboardCoreView',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DashboardCoreFooter: () => import('./Footer'),
  },
}
</script>
